module.exports = __webpack_public_path__ + "static/media/rar.0fc62941.svg";